import { render, staticRenderFns } from "./PanelBasic.vue?vue&type=template&id=77f0c23f&"
import script from "./PanelBasic.vue?vue&type=script&lang=js&"
export * from "./PanelBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f0c23f')) {
      api.createRecord('77f0c23f', component.options)
    } else {
      api.reload('77f0c23f', component.options)
    }
    module.hot.accept("./PanelBasic.vue?vue&type=template&id=77f0c23f&", function () {
      api.rerender('77f0c23f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/panels/PanelBasic.vue"
export default component.exports